import { FC } from 'react';
import { ReactComponent as NoAvatarSvg } from 'assets/img/noAvatar.svg';
import styles from './Client.module.scss';

interface ClientTypes {
  showMenu: () => void;
  fio?: string;
}

export const Client: FC<ClientTypes> = ({ showMenu }) => {
  return (
    <div className={styles.root} onClick={showMenu}>
      <div className={styles.avatar}>
        <NoAvatarSvg />
      </div>
    </div>
  );
};
